module.exports = __webpack_public_path__ + "static/media/quarantine_1.a512d456.png";